/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              projectName.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */
var novicell = novicell || {};
var finansudd = finansudd || {};

// Document ready
$(function () {

    svg4everybody();

    //FitVids on all videos
   // $('body').fitVids();

	finansudd.scrollTo.init($('a.scroll-trigger'));

	finansudd.video.openVideoOverlay($('[data-video-src]'));
	finansudd.slider.testimonialSlider($('.testimonial-slider'));
	finansudd.slider.videoSlider($('.video-slider'));
	finansudd.footer.toggleList($('.footer-headline.has-list'));
	finansudd.favorites.init();

	finansudd.menu.triggerMenuHolder($('#mobile-menu-holder'));
	finansudd.submenu.init($('#navigation-left'));
	
	finansudd.newslist.initNews();
	finansudd.servicelist.initServices();
	// finansudd.courselist.initCourses();
	finansudd.curriculalist.initCurricula();


	finansudd.search.focusEvent();
	finansudd.search.preventSearch();


	finansudd.course.init();

	if($('.new-filter').length) {
	    finansudd.filter.toggleDropdown();
	    finansudd.filter.toggleMobileFilter();
	    finansudd.filter.resetFilters();
	}

    finansudd.frontpageHero.init();

    finansudd.toolbar.toggleMenu();
    finansudd.toolbar.toggleSearch('#search-icon');

    finansudd.forms.init();
    finansudd.trigger.init();
    finansudd.ctabanner.init();

    novicell.responsiveImages.init();
	novicell.responsiveLazyloadImage.onLoad();

    novicell.autocomplete.init();

    finansudd.overlay.toggleOverlay();
    finansudd.overlay.setRteLinkOverlay();
    novicell.customSelect.init();

    finansudd.socialShare.init($('.social-share'));
}); // Document ready end

/*
 *  Use the following if needed
 */

//// Window load
//$(window).load(function(e){
//	finansudd.menu.setWidth();
//}); // Window load


$(window).smartresize(function(e){
	novicell.responsiveImages.init();
	novicell.responsiveLazyloadImage.onResize();
})

$(window).smartscroll(function(e){
	novicell.responsiveImages.lazyloadImages('[lazyload]');
	novicell.responsiveLazyloadImage.onScroll();
	
})

